import * as Yup from 'yup';

export default Yup.object().shape({
  name: Yup.string().required(),
  description: Yup.string().required(),
  roles: Yup.array().min(1, "Pasirinkite bent vieną rolę").required()
})